// src/components/ui/BotaoEditarExcluir/ButtonEditar.jsx
import EditIcon from "@mui/icons-material/Edit";

export default function ButtonEditar({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="p-1"
      style={{
        color: "#626262",
        cursor: "pointer",
      }}
      title="Editar"
    >
      <EditIcon fontSize="small" />
    </button>
  );
}
